export default {
  badge: 'Test',
  badge_title: 'Test restaurant',
  notice: 'This is a test restaurant. Orders placed here are for testing.',
};
